import React, {Component} from 'react';
import {BackButton} from '../../components/BackButton/BackButton';
import './PrivacyPolicy.css';

export class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);

    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  render() {
    console.log(`REACT_APP_PLACEHOLDER1: ${process.env.REACT_APP_PLACEHOLDER1}`);
    return (
      <div className="Regular-page ui stackable center aligned padded column grid">
        <div className="one wide column">
        </div>

        <div className="ten wide column center aligned">

          <BackButton onClick={this.handleBackButtonClick}/>

          <div>
            &nbsp;
          </div>

          <div>
            <p>
              Privacy Policy<br/>
              Last Updated: April 27, 2018
            </p>
          </div>

          <div>
            &nbsp;
          </div>

          <div className="left-aligned">
            
            Error!
            
          </div>

        </div>

        <div className="one wide column">
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/PrivacyPolicy.js